var _path, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 10.0005C13 11.658 11.6575 13.0005 10 13.0005C8.3425 13.0005 7 11.658 7 10.0005C7 8.34302 8.3425 7.00052 10 7.00052C11.6575 7.00052 13 8.34302 13 10.0005M10 13.9237C7.011 13.9237 4.195 12.4474 2.399 10.0005C4.195 7.55359 7.011 6.0763 10 6.0763C12.989 6.0763 15.805 7.55359 17.601 10.0005C15.805 12.4474 12.989 13.9237 10 13.9237M10 4C5.724 4 1.999 6.41682 0 10.0005C1.999 13.5842 5.724 16 10 16C14.276 16 18.001 13.5842 20 10.0005C18.001 6.41682 14.276 4 10 4",
    fill: "#1CCFCA"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 20,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 10.0005C13 11.658 11.6575 13.0005 10 13.0005C8.3425 13.0005 7 11.658 7 10.0005C7 8.34302 8.3425 7.00052 10 7.00052C11.6575 7.00052 13 8.34302 13 10.0005M10 13.9237C7.011 13.9237 4.195 12.4474 2.399 10.0005C4.195 7.55359 7.011 6.0763 10 6.0763C12.989 6.0763 15.805 7.55359 17.601 10.0005C15.805 12.4474 12.989 13.9237 10 13.9237M10 4C5.724 4 1.999 6.41682 0 10.0005C1.999 13.5842 5.724 16 10 16C14.276 16 18.001 13.5842 20 10.0005C18.001 6.41682 14.276 4 10 4",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.cec92511af294cfe8090fa441c82c971.svg";
export { ForwardRef as ReactComponent };